module.exports = __webpack_public_path__ + "static/media/landing-kitty12.1bb81e18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty12.svg
// module id = 125
// module chunks = 0